<template>
    <icon-button
        v-if="iconOnly"
        :tooltip="buttonTooltip"
        icon="fa-user-plus"
        iconStyle="solid"
        size="sm"
        @click="openInviteModal"
    ></icon-button>
    <base-button
        v-else
        :text="trans('client-portal.invite-btn.invite')"
        icon="fa-user-plus"
        iconStyle="solid"
        size="sm"
        :color="primaryColor ? 'primary' : null"
        @click="openInviteModal"
    ></base-button>
</template>

<script>
import { defineAsyncComponent } from 'vue';

export default {
    name: 'CpInvite',
    props: {
        project: {
            type: Object,
            required: true,
        },
        iconOnly: Boolean,
        primaryColor: Boolean,
    },
    computed: {
        buttonTooltip() {
            return trans('client-portal.invite-btn.invite');
        },
    },
    methods: {
        openInviteModal() {
            this.createModal({
                data: {
                    component: defineAsyncComponent(() =>
                        import('@js/client-portal/vue-components/settings/invite/cp-invite-contacts.vue')),
                    style: { width: '700px' },
                    data: {
                        project: this.project,
                    },
                    on: {
                        invited: () => {
                            app.closeCurrentModal();
                        },
                    },
                },
            });
        },
    },
};

</script>
